var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4762 7.66667H16.5238V5.7619C16.5238 3.13333 14.3904 1 11.7619 1C9.1333 1 6.99996 3.13333 6.99996 5.7619V7.66667H5.04758C3.99996 7.66667 3.14282 8.52381 3.14282 9.57143V19.0952C3.14282 20.1429 3.99996 21 5.04758 21H18.4762C19.5238 21 20.3809 20.1429 20.3809 19.0952V9.57143C20.3809 8.52381 19.5238 7.66667 18.4762 7.66667ZM11.7619 16.2381C10.7143 16.2381 9.85711 15.381 9.85711 14.3333C9.85711 13.2857 10.7143 12.4286 11.7619 12.4286C12.8095 12.4286 13.6666 13.2857 13.6666 14.3333C13.6666 15.381 12.8095 16.2381 11.7619 16.2381ZM14.7142 7.66667H8.80949V5.7619C8.80949 4.13333 10.1333 2.80952 11.7619 2.80952C13.3904 2.80952 14.7142 4.13333 14.7142 5.7619V7.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/Lock Icon.7eba1ccfc27bba495f517d9dd81f761f.svg";
export { ForwardRef as ReactComponent };